/*
 * HYDN · Selectores de color en tarjetas.
 * Escritorio: pasar el cursor muestra el color; clic lo selecciona (la ficha abre con ese color).
 * Táctil: primer toque selecciona y cambia la foto; segundo toque sobre el mismo color abre la ficha.
 */
(() => {
  if (window.__hydnSwatches) return;
  window.__hydnSwatches = true;

  const preloaded = new Set();
  let lastPointer = 'mouse';

  const cardOf = (el) => el.closest('.card-wrapper');
  const mainImg = (card) => card && card.querySelector('.card__media .media > img:first-child');

  function remember(img) {
    if (!img || img.dataset.hydnOrigSrc) return;
    img.dataset.hydnOrigSrc = img.getAttribute('src') || '';
    img.dataset.hydnOrigSrcset = img.getAttribute('srcset') || '';
    img.dataset.hydnOrigAlt = img.getAttribute('alt') || '';
  }

  function preload(sw) {
    const src = sw.dataset.src;
    if (!src || preloaded.has(src)) return;
    preloaded.add(src);
    const i = new Image();
    i.decoding = 'async';
    if (sw.dataset.srcset) {
      i.srcset = sw.dataset.srcset;
      const img = mainImg(cardOf(sw));
      if (img && img.sizes) i.sizes = img.sizes;
    }
    i.src = src;
  }

  function show(card, src, srcset, alt) {
    const img = mainImg(card);
    if (!img || !src || img.getAttribute('src') === src) return;
    remember(img);
    if (srcset) img.setAttribute('srcset', srcset);
    else img.removeAttribute('srcset');
    img.setAttribute('src', src);
    if (alt) img.setAttribute('alt', alt);
  }

  function showSwatch(sw) {
    const card = cardOf(sw);
    if (!card) return;
    card.classList.add('hydn-swatch-active');
    show(card, sw.dataset.src, sw.dataset.srcset, sw.dataset.alt);
  }

  function restore(group) {
    const card = cardOf(group);
    if (!card) return;
    const selected = group.querySelector('.hydn-swatch[aria-pressed="true"]');
    if (selected && card.dataset.hydnSelected === '1') {
      showSwatch(selected);
      return;
    }
    const img = mainImg(card);
    if (img && img.dataset.hydnOrigSrc) {
      show(card, img.dataset.hydnOrigSrc, img.dataset.hydnOrigSrcset, img.dataset.hydnOrigAlt);
    }
    card.classList.remove('hydn-swatch-active');
  }

  function select(sw) {
    const group = sw.closest('[data-hydn-swatches]');
    const card = cardOf(sw);
    group.querySelectorAll('.hydn-swatch').forEach((b) => b.setAttribute('aria-pressed', String(b === sw)));
    if (card) {
      card.dataset.hydnSelected = '1';
      card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        if (!a.dataset.hydnOrigHref) a.dataset.hydnOrigHref = a.getAttribute('href');
        a.setAttribute('href', sw.dataset.url);
      });
    }
    showSwatch(sw);
  }

  document.addEventListener(
    'pointerdown',
    (e) => {
      lastPointer = e.pointerType || 'mouse';
    },
    true
  );

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const sw = e.target.closest && e.target.closest('.hydn-swatch');
    if (!sw) return;
    preload(sw);
    showSwatch(sw);
  });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType !== 'mouse') return;
    const group = e.target.closest && e.target.closest('[data-hydn-swatches]');
    if (!group || (e.relatedTarget && group.contains(e.relatedTarget))) return;
    restore(group);
  });

  document.addEventListener('focusin', (e) => {
    const sw = e.target.closest && e.target.closest('.hydn-swatch');
    if (sw) preload(sw);
  });

  document.addEventListener('click', (e) => {
    const sw = e.target.closest && e.target.closest('.hydn-swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    const alreadySelected = sw.getAttribute('aria-pressed') === 'true' && cardOf(sw) && cardOf(sw).dataset.hydnSelected === '1';
    if (alreadySelected && lastPointer !== 'mouse') {
      window.location.href = sw.dataset.url;
      return;
    }
    select(sw);
  });
})();
